<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<el-button type="warning" size="mini" icon="el-icon-edit" @click="addKeylinkType('')">添加优化词分组</el-button>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-dropdown trigger="click">
					<el-button type="primary" icon="el-icon-setting" size="mini">
						筛选
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, key) in items.seconds"
										:key="key"
										:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
										:class="item.checked ? 'color-blue' : ''"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteKeywordGroup">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh">刷新</el-button>
				<el-table
					ref="multipleTable"
					:data="keyLinkTypeList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="ktid"
					:stripe="true"
					:default-sort="{ prop: 'ctime', order: 'ascending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
				>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="ktid" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="mid" label="所属模型" >
						<template slot-scope="scope">
							{{mlist[scope.row.mid].modelname}}
						</template>
					</el-table-column>
					<el-table-column prop="keytypename" label="优化词分组名称" show-overflow-tooltip></el-table-column>
					<el-table-column prop="keywordlist" label="关键词列表" show-overflow-tooltip></el-table-column>
					<el-table-column prop="description" label="网页简介" show-overflow-tooltip></el-table-column>
					<el-table-column prop="isclass" label="启用状态">
						<template slot-scope="scope">
							<i :class="scope.row.isclass ? 'el-icon-unlock color-green' : 'el-icon-lock color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="addKeylinkType(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="thispage"
						:page-sizes="pageSizes"
						:page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 15, 20, 30], //每页显示个数选择器
			sort_param: '', //排序字段
			sort_type: '', //排序方式ascending = asc;descending = desc,'' = asc;
			keyLinkTypeList: [],
			selectedtypeIds: [],
			mlist:[],
			filtrateList:[
				{
					label: '所属模型',
					paramValue: 'mid',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						}
					]
				}
			],
			selectParams: [],
		};
	},
	mounted() {
		this.getKeylinkTypeList(1);
	},
	methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getKeylinkTypeList();
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getKeylinkTypeList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getKeylinkTypeList();
		},
		getKeylinkTypeList(firstLoad = 0) {
			this.selectedKeywordIds = [];//初始化选中值
			console.log(this.selectParams);
			let separ = [];
			for(let i in this.selectParams){
				console.log(i,this.selectParams[i]);
				separ.push({param:i,paramVal:this.selectParams[i]});
			}
			this.$axios({
				url: this.HOST + '/admin.seo/keyLinkTypeList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage: this.thispage,
					pagesize: this.pagesize,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					firstLoad:firstLoad,
					selectParams:separ
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.keyLinkTypeList = res.data.data;
						this.total = res.data.total;
						if(firstLoad){
							this.mlist = res.data.mlist;
							for(let i in this.mlist){
								this.filtrateList[0].seconds.push({
									val:this.mlist[i].mid,
									label:this.mlist[i].modelname
								})
							}
						}
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].ktid);
			}
			this.selectedtypeIds = arr;
			console.log(this.selectedtypeIds);
		},
		addCommand(command){
			console.log('add:',command);
		},
		setCommand(command){
			console.log('set:',command);
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getKeylinkTypeList();
		},
		// 全选
		selectAll() {
			this.keyLinkTypeList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedtypeIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.keyLinkTypeList.map(item => {
				if (this.selectedtypeIds.indexOf(item.ktid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.ktid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedtypeIds = diff;
			console.log(this.selectedtypeIds);
		},
		deleteKeywordGroup() {
			if (!this.selectedtypeIds.length) {
				this.$message.error('尚未选中任何优化词分组！');
				return false;
			}
			this.$confirm('是否要删除所选优化词分组？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.seo/deleteKeywordGroup',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							attrIds: this.selectedtypeIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getKeywordList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		addKeylinkType(scope){
			if(scope){
				this.$router.push({path:'/keylink/addKeylinkType',query:{'ktid':scope.ktid}});
			}else{
				this.$router.push({path:'/keylink/addKeylinkType',query:{'ktid':''}});
			}
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown{
			margin: 0 10px;
		}
	}
	.el-button + .el-button-group{
		margin-left: 10px;
	}
}
</style>
